import { useTranslation } from 'react-i18next';
import { cn } from 'utils/utils';
import Icon from './Icons/Icon';

export default function SmallSubmitButton ({
  className = '',
  text = '',
  loading = false,
  disabled = false,
}) {
  const { t } = useTranslation('common');
  return (
    <button
      className={cn(
        !className || !className.includes('absolute')  ? 'relative' : '',
        'flex items-center justify-center w-6 h-6 p-1 text-white rounded-full cursor-pointer',
        loading || disabled ? 'bg-red-300' : 'bg-red',
        className
      )}
      disabled={disabled || loading}
      type="submit"
    >
      {loading ? (
        <Icon
          className="animate-spin"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            transformOrigin: 'top left',
            width: '3.25rem',
            height: '3.25rem',
            color: '#E70000',
          }}
          icon="loading"
        />
      ) : null}
      <Icon icon="arrow" />
      <span className="sr-only">{text || t('button.submit')}</span>
    </button>
  );
}
